import cx from 'classnames';
import {
    COMPLAINT_CANCEL,
    COMPLAINT_EXPLAIN_SIMPLE,
    COMPLAINT_SUBMIT_TO_ADMINS,
    COMPLAINT_SUBMIT_TO_GROUP_MODS,
    COMPLAINT_SUBMIT_TO_MODS,
} from 'mk/autogenerated/translations/ComplaintForm.0e055e7c50c6ceff101d37e1dd41a95c'
import Btn, { BtnType } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import TextareaField from 'mk2/components/forms/TextareaField';
import { TITLES } from 'mk2/containers/Complaint/Complaint.constants';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { interpolate } from 'mk2/services/i18n';
import React from 'react';
import styles from './ComplaintForm.mscss';

export interface ComplaintFormData {
    comment: string;
}

interface OwnProps {
    className?: string;
    entity: string;
    id: number;
    inForum: boolean;
    inGroups: boolean;
    scrollOffset?: number; // When complaint is displayed we are scrolling him into view - this can be used to add some offset

    onSend(entity: string, id: number, fd: ComplaintFormData);
    onCancel(entity: string, id: number);
}

type Props = OwnProps;

class ComplaintFormComponent extends React.Component<Props & MKReduxFormInjectedProps<ComplaintFormData, Props>> {

    private container: HTMLDivElement;

    public componentDidMount() {
        const rect = this.container.getBoundingClientRect();
        // Detect if the container is in the viewport
        if (rect.top < 0 || rect.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
            // Scroll to viewport
            this.container.scrollIntoView(true);
            if (this.props.scrollOffset && window.scrollY) {
                window.scroll(0, window.scrollY - this.props.scrollOffset);
            }
        }
    }

    public render() {
        const { className, entity, inForum, inGroups, form, handleSubmit } = this.props;

        const title = interpolate(TITLES[entity]);

        return (
            <div className={cx(styles.ComplaintForm, className)} ref={(r) => this.container = r}>
                <div className={styles.ComplaintForm__title}>
                    <i className="fa fa-exclamation-triangle" /> {title}
                </div>

                <form className={styles.ComplaintForm__form} onSubmit={handleSubmit}>
                    <TextareaField
                        name="comment"
                        label={COMPLAINT_EXPLAIN_SIMPLE}
                        rows={1}
                        autoFocus
                    />

                    <div className={styles.ComplaintForm__form__buttons}>
                        <SubmitButton
                            key="send"
                            label={
                                inGroups
                                    ? COMPLAINT_SUBMIT_TO_GROUP_MODS
                                    : inForum
                                    ? COMPLAINT_SUBMIT_TO_MODS
                                    : COMPLAINT_SUBMIT_TO_ADMINS
                            }
                            icon="fa-paper-plane"
                            formName={form}
                        />
                        <Btn
                            key="cancel"
                            type={BtnType.Link}
                            label={COMPLAINT_CANCEL}
                            onClick={this.handleOnCancel}
                        />
                    </div>
                </form>
            </div>
        );
    }

    private handleOnCancel = () => {
        const { onCancel, entity, id } = this.props;
        onCancel(entity, id);
    };
}

export const ComplaintFormFactory = (formName: string) => mkReduxFormNew<ComplaintFormData, Props>({
    formName,
    onSave: (values, props) => props.onSend(props.entity, props.id, values),
    disableDirtyCheck: true,
})(ComplaintFormComponent);
